import type { RegistrationData } from '../../types';

import dictionary from './signing-helpers.dictionary.json';

export function getHeaderContent(data: RegistrationData) {
  if (data.completed) {
    return dictionary.completed;
  }
  if (data.regStep === 1) {
    return dictionary.sign;
  }
  if (data.regStep === 3) {
    return dictionary.createPass;
  }

  return dictionary.default;
}

export function getBackwardButtonText(data: RegistrationData) {
  if (data.regStep === 2) {
    return dictionary.back;
  }

  return dictionary.cancel;
}
